import React from "react";
import { Switch as AntdSwitch } from "antd";
import styled from "@emotion/styled";

const StyledSwitch = styled(AntdSwitch)<{ color?: string }>(
  ({ theme, color }) => ({
    "&.ant-switch.ant-switch-checked": {
      backgroundColor: `${color} !important`,
    },
  }),
);

type Props = {
  toggleEvent: () => void;
  color?: string;
  checked?: boolean;
};
const Switch = ({ toggleEvent, color = "#111", checked }: Props) => {
  return (
    <StyledSwitch onChange={toggleEvent} color={color} checked={checked} />
  );
};

export default Switch;
